import { UseFormReturn } from "react-hook-form";
import { ClienteFormValues } from "../ClienteFormSchema";
import { FormattedTextField } from "@/components/form/FormattedTextField";
import {
  PipelineFormSection,
  pipelineFieldGridClass,
  usePipelineForm,
} from "@/components/form/PipelineFormContext";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Info } from "lucide-react";

interface PersonalInfoStepSimplificadoProps {
  form: UseFormReturn<ClienteFormValues>;
}

export function PersonalInfoStepSimplificado({ form }: PersonalInfoStepSimplificadoProps) {
  const { isPipeline } = usePipelineForm();
  const gridClass = pipelineFieldGridClass(isPipeline);

  return (
    <div>
      {!isPipeline && (
        <Alert className="mb-6">
          <Info className="h-4 w-4" />
          <AlertDescription>
            Preencha pelo menos o nome e telefone do lead. CPF e email são opcionais no primeiro contato.
          </AlertDescription>
        </Alert>
      )}

      <PipelineFormSection>
        <div className={gridClass}>
          <FormattedTextField
            form={form}
            name="nome"
            label="Nome Completo"
            formatter="texto"
            placeholder="Nome completo do lead"
            required
          />

          <FormattedTextField
            form={form}
            name="tel1"
            label="Telefone Principal"
            formatter="telefone"
            placeholder="(00) 00000-0000"
            required
          />

          <FormattedTextField
            form={form}
            name="cpf"
            label="CPF/CNPJ (opcional)"
            formatter="cpfCnpj"
            placeholder="000.000.000-00"
          />

          <FormattedTextField
            form={form}
            name="email"
            label="Email (opcional)"
            formatter="texto"
            placeholder="exemplo@email.com"
          />
        </div>
      </PipelineFormSection>
    </div>
  );
}
